var exports = {
  "K": "xa15a2ab7--0f918c--icon",
  "w": "xa15a2ab7--0f918c--logo",
};

module.exports = exports;
